import React from 'react';
import { Link } from 'react-router-dom';
import { WhatsAppIcon, PhoneCallIcon } from './icons';
import {
  PHONE,
  PHONE_DISPLAY,
  waUrl,
  waMessages,
  reportConversion,
} from '../utils/leads';

const Footer: React.FC = () => {
  const ctaUrl = waUrl(waMessages.general);

  return (
    <footer className="bg-ink-950 border-t border-white/[0.06]">
      <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8 py-14 md:py-16">
        <div className="grid md:grid-cols-3 gap-10">
          {/* Brand */}
          <div>
            <Link to="/" className="inline-flex items-center font-display mb-4">
              <span className="text-3xl font-bold text-ember">JSON</span>
              <span className="text-3xl font-bold text-white">PLAY</span>
            </Link>
            <p className="text-white/50 leading-relaxed max-w-xs mb-6">
              A software studio building websites, mobile apps and AI products
              for ambitious businesses.
            </p>
            <a
              href={ctaUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-whatsapp !py-3 !px-6 text-sm"
              onClick={() => reportConversion(ctaUrl)}
            >
              <WhatsAppIcon className="w-5 h-5" />
              Start a conversation
            </a>
          </div>

          {/* Links */}
          <div>
            <h4 className="font-display font-semibold text-white mb-5">
              Explore
            </h4>
            <ul className="space-y-3">
              {[
                ['Home', '/'],
                ['About', '/about'],
                ['Contact', '/contact'],
                ['Privacy Policy', '/privacy'],
                ['Terms of Service', '/terms'],
              ].map(([name, path]) => (
                <li key={path}>
                  <Link
                    to={path}
                    className="text-white/50 hover:text-ember transition-colors text-sm"
                  >
                    {name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-display font-semibold text-white mb-5">
              Get in touch
            </h4>
            <ul className="space-y-4 text-sm">
              <li>
                <a
                  href={`tel:${PHONE}`}
                  className="flex items-center gap-3 text-white/50 hover:text-ember transition-colors"
                >
                  <PhoneCallIcon className="w-4 h-4 text-ember" />
                  {PHONE_DISPLAY}
                </a>
              </li>
              <li>
                <a
                  href="mailto:hello@jsonplay.com"
                  className="flex items-center gap-3 text-white/50 hover:text-ember transition-colors"
                >
                  <svg className="w-4 h-4 text-ember" fill="none" stroke="currentColor" strokeWidth={1.8} viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75" />
                  </svg>
                  hello@jsonplay.com
                </a>
              </li>
              <li className="flex items-center gap-3 text-white/50">
                <svg className="w-4 h-4 text-ember" fill="none" stroke="currentColor" strokeWidth={1.8} viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z" />
                </svg>
                India · working with clients worldwide
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-white/[0.06]">
        <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8 py-5 pb-24 md:pb-5">
          <p className="text-white/35 text-xs text-center md:text-left">
            © {new Date().getFullYear()} JSONPLAY. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
